import React from "react";
import { Button } from "../../../designSystem/button/Button";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { iconName } from "../../../designSystem/icons/Icons";
import { ProtectedPageWrapper } from "../../../designSystem/layouts/pageWrappers/ProtectedPageWrapper";
import { SingleColumnLayout } from "../../../designSystem/layouts/SingleColumnLayout";
import { MessageCard } from "../../../designSystem/Message";
import { PageHeader } from "../../../designSystem/PageHeader";
import { PageSection } from "../../../designSystem/PageSection";
import { H2 } from "../../../designSystem/typography/Heading";

type ActivityListingPageScaffoldProps = {
    headerText: string,
    pastHeaderText: string,
    newActivityButtonText: string,
    selectedMenuItemKey: string,
    toolBarButtons?: React.ReactNode,
    currentActivities: { id: string, component: React.ReactNode; }[],
    pastActivities: { id: string, component: React.ReactNode; }[],
    onClickNew: () => void,
    headerIcon?: iconName;
};
export function ActivityListingPageScaffold (props: ActivityListingPageScaffoldProps): JSX.Element
{
    return (
        <ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey={props.selectedMenuItemKey}>
            <SingleColumnLayout
                noDivider
                contentContainer={
                    <>
                        <PageHeader
                            headerIcon={props.headerIcon}
                            headerText={props.headerText}
                            headerStyle="secondary-gray"
                            buttons={props.toolBarButtons}
                        />

                        <Flex justifyContent="flex-end" gap={4}>
                            <Button variant="filled" icon="actions_plus" text={props.newActivityButtonText} onClick={props.onClickNew} />
                        </Flex>

                        {props.currentActivities.length > 0
                            ? <Flex flexDirection="column" gap={24}>
                                {props.currentActivities.map(activity =>
                                    <React.Fragment key={activity.id}>
                                        {activity.component}
                                    </React.Fragment>
                                )}
                            </Flex>
                            : <MessageCard variant="info">
                                Ingen aktiviteter er planlagt
                            </MessageCard>
                        }

                        {props.pastActivities.length > 0 &&
                            <PageSection
                                header={<H2 color="gray">{props.pastHeaderText}</H2>}
                                defaultCollapsed={props.currentActivities.length > 0}>
                                <Flex flexDirection="column" gap={24}>
                                    {props.pastActivities.map(activity =>
                                        <React.Fragment key={activity.id}>
                                            {activity.component}
                                        </React.Fragment>
                                    )}
                                </Flex>
                            </PageSection>
                        }
                    </>
                }
            />
        </ProtectedPageWrapper>
    );
}